import * as React from "react";
import { Button, Gapped, Modal } from "react-ui";

import {
    EXPERT_REPLACE_PAGE_CANCEL_CLICK,
    EXPERT_REPLACE_PAGE_CANCEL_REQUEST,
    EXPERT_REPLACE_PAGE_DOWNLOAD_CLICK,
    EXPERT_REPLACE_PAGE_REPLACE_CLICK,
} from "../../metricsAction";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { Icon } from "../../Icons/Icon";

import { Attachment, Footer } from "./ReplaceAttachment.styles";

export interface Props {
    onAttachmentReplace: () => void;
    onClose: () => void;
    onGoToPreviewPage: () => void;
    onDownloadNote: () => void;
}

export function ReplaceAttachment(props: Props): JSX.Element {
    const track = useMetrics();

    const handleAttachmentReplace = (): void => {
        track(EXPERT_REPLACE_PAGE_REPLACE_CLICK);
        props.onAttachmentReplace();
    };

    const handleClose = (): void => {
        track(EXPERT_REPLACE_PAGE_CANCEL_CLICK);
        props.onGoToPreviewPage();
    };

    const handleCloseRequest = (): void => {
        track(EXPERT_REPLACE_PAGE_CANCEL_REQUEST);
        props.onClose();
    };

    const handleDownloadNote = (): void => {
        track(EXPERT_REPLACE_PAGE_DOWNLOAD_CLICK);
        props.onDownloadNote();
    };

    return (
        <Modal onClose={handleCloseRequest}>
            <Modal.Header>Заменить файл пояснений?</Modal.Header>
            <Modal.Body>
                <Attachment>
                    К отчету уже приложен файл пояснений. Заменить его финансовым анализом, сформированным модификатором
                    «Эксперт»?
                </Attachment>
            </Modal.Body>
            <Modal.Footer panel>
                <Footer>
                    <Gapped gap={10}>
                        <Button onClick={handleAttachmentReplace} use="primary" size="medium">
                            Заменить
                        </Button>
                        <Button onClick={handleClose} size="medium">
                            Назад
                        </Button>
                    </Gapped>
                    <Button use="link" size="medium" onClick={handleDownloadNote}>
                        <Icon name="NetDownloadIcon" />
                        Скачать
                    </Button>
                </Footer>
            </Modal.Footer>
        </Modal>
    );
}
